import { Model } from "@interfaces/model.interface";

export interface UserLoginCountryBypass extends Model {
	endDate: Date;
	startDate: Date;
	userId: number;
}

export class UserLoginCountryBypass implements UserLoginCountryBypass {
	constructor(data?: Partial<UserLoginCountryBypass>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}